import { Product, Filter, Pagination } from "../types";

export const getProductsFromKlevuAPI = async () => {
  const response = await fetch("https://api.section-rendering.com/products");
  const json = await response.json();
  return convertResponseFromKlevuAPI(json);
};

const convertResponseFromKlevuAPI = (response: KlevuResponse) => response;

// Note: Some mapping and new typing will have to be done here.
type KlevuResponse = {
  products: Product[];
  productCount: number;
  pagination: Pagination;
  filters: Filter[];
};
